import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { DetailsSkeleton } from 'src/common/components/DetailsSkeleton';
import {
  PanelCard,
  PanelCardContent,
  PanelCardTitle,
} from 'src/common/components/Layouts/PanelCard/PanelCard';

export const ESimProfilePanelSuspense = () => {
  return (
    <PanelCard>
      <PanelCardContent>
        <PanelCardTitle>
          <Skeleton data-testid="skeleton-details" width={'30%'} height={24} />
        </PanelCardTitle>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 16, mt: 16, ml: -12 }}>
          <DetailsSkeleton numberOfRepetitions={2} />
        </Box>
      </PanelCardContent>
    </PanelCard>
  );
};
